export default __webpack_public_path__ + "static/media/imagotype_primary.d2c070e7.svg";